export const SAVE_SEARCH_FIELD = 'SAVE_SEARCH_FIELD';

export const saveSearchField = save => dispatch => dispatch({
  type: SAVE_SEARCH_FIELD,
  payload: save
})


// WEBPACK FOOTER //
// ./src/actions/SearchFieldAction.js